


















































































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue'
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import {ncpPopup} from '@/utils/ncp';
import {OriginalAddress, PostReturnsPredictRequest, ResponsibleObjectType} from 'supporter';
import {ComponentItemsClaimDataType} from '@/views/claim/components/dataType/ComponentDataType';
@Component({
  components: {CompRadioButton, CompSelectBox}
})
export default class ComponentReturnAddress extends Vue { //J

  @Prop({required: true})
  private claimOrderOptions!: {};

  @Prop({required: true})
  private pageName!: string;

  @Prop({default: 'BUYER'})
  private responsibleObjectType!: string;  

  @Prop({required: true})
  private objJson!: string;

  @Prop({required: true})
  private postPredict!: {};

  @Prop({default: ''})
  private refundType!: string ;

  @Prop({default: false})
  private modifyClaim!: boolean;

  @Prop({required: true})
  private orderOptionsApply!: ComponentItemsClaimDataType;

  @Prop({default: false})
  private escrowOrder!: boolean;

  @Prop({default: false})
  private payType!: string;

  @Watch('refundType')
  onRefundTypeChanged() {
    if (this.pageName == 'ReturnPopup'){
      if(this.payType === 'NAVER_PAY'){
        this.returnWayTypeDisabled = true;
        this.returnWayType = 'BUYER_DIRECT_RETURN'
      }

      if (this.escrowOrder){
        this.returnWayType = 'SELLER_COLLECT'
        if (this.refundType == 'KCP'){
          this.returnWayTypeDisabled = true
        } else if (this.refundType == 'CASH') {
          this.returnWayTypeDisabled = false
        } else {
          this.returnWayTypeDisabled = false
        }
      }
    }
  }
  private orderCntMap: Map<number, number> = new Map();
  private returnWayTypeDisabled: boolean = false
  private unApprovedDisabled: boolean = false;
  private unApprovedYn: boolean = false;
  private countryCd: string = 'KR'
  private isExpanded = false;
  private returnWayType: string = 'SELLER_COLLECT'
  private deliveryCompanyType: string = ''
  private invocieNo: string = ''
  private returnAddress: string = ''
  private returnName: string = ''
  private returnJibunAddress: string = ''
  private returnContact1: string = ''
  private returnContact2: string = ''
  private exchangeName: string = '';
  private exchangeJibunAddress: string = ''
  private exchangeContact1: string = ''
  private exchangeContact2: string = '';
  private exchangeZipCd: string = ''
  private exchangeAddress: string = ''
  private exchangeDetailAddress: string = '';
  private returnDeliveryNote: string = '';
  private exchangeDeliveryNote: string = '';
  private returnWayTypes = {
    name: 'returnWayType',
    data: [
      {
        id: 'SELLER_COLLECT',
        value: 'SELLER_COLLECT',
        dispaly: 'CLAIM_RETURNPOPUP_RETURNWAYTYPE1'
      },
      {
        id: 'BUYER_DIRECT_RETURN',
        value: 'BUYER_DIRECT_RETURN',
        dispaly: 'CLAIM_RETURNPOPUP_RETURNWAYTYPE2'
      }
    ]
  };
  private get deliveryCompanyTypeList(){
    let list: any = [
      {
        value: '',
        name: this.$t('CLAIM_RETURNPOPUP_SELECTEDVALUE')
      },
      {
        value: 'CJ',
        name: this.$t('CLAIM_RETURNPOPUP_CJ')
      },
      {
        value: 'POST',
        name: this.$t('CLAIM_RETURNPOPUP_POST')
      },
      {
        value: 'HANJIN',
        name: this.$t('CLAIM_RETURNPOPUP_HANJIN')
      },
      {
        value: 'GTX',
        name: this.$t('CLAIM_RETURNPOPUP_GTX')
      },
      {
        value: 'LOTTE',
        name: this.$t('CLAIM_RETURNPOPUP_LOTTE')
      },
      {
        value: 'KGB',
        name: this.$t('CLAIM_RETURNPOPUP_KGB')
      },
      {
        value: 'LOGEN',
        name: this.$t('CLAIM_RETURNPOPUP_LOGEN')
      },
      {
        value: 'GSI',
        name: this.$t('CLAIM_RETURNPOPUP_GSI')
      },
      {
        value: 'KGL',
        name: this.$t('CLAIM_RETURNPOPUP_KGL')
      },
      {
        value: 'INTRAS',
        name: this.$t('CLAIM_RETURNPOPUP_INTRAS')
      },
      {
        value: 'UPS',
        name: this.$t('CLAIM_RETURNPOPUP_UPS')
      },
      {
        value: 'YAMATO',
        name: this.$t('CLAIM_RETURNPOPUP_YAMATO')
      },
      {
        value: 'SAGAWA',
        name: this.$t('CLAIM_RETURNPOPUP_SAGAWA')
      },
      {
        value: 'JAPANPOST',
        name: this.$t('CLAIM_RETURNPOPUP_JAPANPOST')
      },
      {
        value: 'CHUNIL',
        name: this.$t('CLAIM_RETURNPOPUP_CHUNIL')
      },
      {
        value: 'KDEXP',
        name: this.$t('CLAIM_RETURNPOPUP_KDEXP')
      },
      {
        value: 'HDEXP',
        name: this.$t('CLAIM_RETURNPOPUP_HDEXP')
      },
      {
        value: 'ILYANG',
        name: this.$t('CLAIM_RETURNPOPUP_ILYANG')
      },
      {
        value: 'POST_EMS',
        name: this.$t('CLAIM_RETURNPOPUP_POST_EMS')
      },
      {
        value: 'KYOUNGDONG',
        name: this.$t('CLAIM_RETURNPOPUP_KYOUNGDONG')
      },
      {
        value: 'DAESIN',
        name: this.$t('CLAIM_RETURNPOPUP_DAESIN')
      },
      {
        value: 'CVS',
        name: this.$t('CLAIM_RETURNPOPUP_CVS')
      },
      {
        value: 'DHL',
        name: this.$t('CLAIM_RETURNPOPUP_DHL')
      },
      {
        value: 'FEDEX',
        name: this.$t('CLAIM_RETURNPOPUP_FEDEX')
      },
      {
        value: 'GSM',
        name: this.$t('CLAIM_RETURNPOPUP_GSM')
      },
      {
        value: 'WARPEX',
        name: this.$t('CLAIM_RETURNPOPUP_WARPEX')
      },
      {
        value: 'WIZWA',
        name: this.$t('CLAIM_RETURNPOPUP_WIZWA')
      },
      {
        value: 'ACI',
        name: this.$t('CLAIM_RETURNPOPUP_ACI')
      },
      {
        value: 'PANTOS',
        name: this.$t('CLAIM_RETURNPOPUP_PANTOS')
      },{
        value: 'CJ_INTERNATIONAL',
        name: this.$t('CLAIM_RETURNPOPUP_CJ_INTERNATIONAL')
      },
      {
        value: 'TNT',
        name: this.$t('CLAIM_RETURNPOPUP_TNT')
      },{
        value: 'CU',
        name: this.$t('CLAIM_RETURNPOPUP_CU')
      },
      {
        value: 'KUNYOUNG',
        name: this.$t('CLAIM_RETURNPOPUP_KUNYOUNG')
      },{
        value: 'LOTTE_INTERNATIONAL',
        name: this.$t('CLAIM_RETURNPOPUP_LOTTE_INTERNATIONAL')
      },
      {
        value: 'HONAM',
        name: this.$t('CLAIM_RETURNPOPUP_HONAM')
      },{
        value: 'HANIPS',
        name: this.$t('CLAIM_RETURNPOPUP_HANIPS')
      },
      {
        value: 'IPARCEL',
        name: this.$t('CLAIM_RETURNPOPUP_IPARCEL')
      },{
        value: 'SLX',
        name: this.$t('CLAIM_RETURNPOPUP_SLX')
      },
      {
        value: 'USPS',
        name: this.$t('CLAIM_RETURNPOPUP_USPS')
      },{
        value: 'WONDERS',
        name: this.$t('CLAIM_RETURNPOPUP_WONDERS')
      },
      {
        value: 'REGISTPOST',
        name: this.$t('CLAIM_RETURNPOPUP_REGISTPOST')
      },{
        value: 'DHLDE',
        name: this.$t('CLAIM_RETURNPOPUP_DHLDE')
      },
      {
        value: 'EZUSA',
        name: this.$t('CLAIM_RETURNPOPUP_EZUSA')
      },{
        value: 'SWGEXP',
        name: this.$t('CLAIM_RETURNPOPUP_SWGEXP')
      },
      {
        value: 'DAEWOON',
        name: this.$t('CLAIM_RETURNPOPUP_DAEWOON')
      },{
        value: 'DADREAM',
        name: this.$t('CLAIM_RETURNPOPUP_DADREAM')
      },
      {
        value: 'CVSNET',
        name: this.$t('CLAIM_RETURNPOPUP_CVSNET')
      },{
        value: 'ETC',
        name: this.$t('CLAIM_RETURNPOPUP_ETC')
      }      
    ];
    return list;
  }

  private showReturncollinfo:boolean = false;
  private created(){
    this.showReturncollinfo = true;

    this.returnName = (this.claimOrderOptions as any).returnAddress.receiverName
    this.returnContact1 = (this.claimOrderOptions as any).returnAddress.receiverContact1
    this.returnContact2 = (this.claimOrderOptions as any).returnAddress.receiverContact2
    this.returnJibunAddress = (this.claimOrderOptions as any).returnAddress.receiverJibunAddress
    this.zipCd = (this.claimOrderOptions as any).returnAddress.receiverZipCd
    this.address = (this.claimOrderOptions as any).returnAddress.receiverAddress
    this.detailAddress = (this.claimOrderOptions as any).returnAddress.receiverDetailAddress
    this.returnDeliveryNote = (this.claimOrderOptions as any).returnAddress.deliveryMemo

    if (this.pageName == 'ExchangePopupAfter'){
      this.exchangeName = (this.claimOrderOptions as any).exchangeAddress.receiverName
      this.exchangeContact1 = (this.claimOrderOptions as any).exchangeAddress.receiverContact1
      this.exchangeContact2 = (this.claimOrderOptions as any).exchangeAddress.receiverContact2
      this.exchangeZipCd = (this.claimOrderOptions as any).exchangeAddress.receiverZipCd
      this.exchangeAddress = (this.claimOrderOptions as any).exchangeAddress.receiverAddress
      this.exchangeDetailAddress = (this.claimOrderOptions as any).exchangeAddress.receiverDetailAddress
      this.exchangeJibunAddress = (this.claimOrderOptions as any).exchangeAddress.receiverJibunAddress
      this.exchangeDeliveryNote = (this.claimOrderOptions as any).exchangeAddress.deliveryMemo
    }
    this.onRefundTypeChanged();
  }

  private zipCd: string = '';
  private address: string = '';
  private detailAddress: string = '';
  setAddressReturn(address: OriginalAddress) {
    this.zipCd = address.zipCode;
    this.address = address.roadAddress;
    this.detailAddress = address.roadAddressExtra;
    this.returnJibunAddress = address.jibunAddress
    if (this.pageName == 'ReturnPopup') {
      let orderOptionParams: any = [];
      for (let i = 0; i < (this.$parent.$refs.componentItemsClaim as any).optionno.length; i++) {
        let claimCnt = (this.$parent.$refs.componentItemsClaim as any).orderCntMap.get((this.$parent.$refs.componentItemsClaim as any).optionno[i]) || 0;
        orderOptionParams.push({
          claimCnt: claimCnt,
          orderOptionNo: (this.$parent.$refs.componentItemsClaim as any).optionno[i]
        });
      }
      let postRetrunsPredictRequest: PostReturnsPredictRequest = {
        data: {
          responsibleObjectType: (this.$parent.$refs.componentItemsClaim as any).responsibleObjectTypeValue as ResponsibleObjectType,
          refundType: 'PG',
          orderNo: this.orderOptionsApply.orderNo,
          returnDeliveryProposedAmt: 0,
          sellerPaysClaimedDelivery: false,
          returnWayType: 'SELLER_COLLECT',
          returnOrderOptions: orderOptionParams,
          returnAddress: {
            address: address.roadAddress,
            name: '',
            jibunAddress: address.jibunAddress,
            detailAddress: address.roadAddressExtra,
            zipCd: address.zipCode,
            contact1: '',
            contact2: ''
          }
        }
      };

      this.$emit('setData', postRetrunsPredictRequest, 'A');
    } else if (this.pageName == 'ExchangePopupBefore' || this.pageName == 'ExchangePopupAfter') {
      this.$emit('setData');
    }
  }

  setAddressExchange(address: OriginalAddress) {
    this.exchangeZipCd = address.zipCode;
    this.exchangeAddress = address.roadAddress;
    this.exchangeDetailAddress = address.roadAddressExtra;
    this.exchangeJibunAddress = address.jibunAddress

    if (this.pageName == 'ExchangePopupBefore' || this.pageName == 'ExchangePopupAfter') {
      this.$emit('setData');
    }
  }

  callbackReturn(address: OriginalAddress) {
    (window as any).addressCallback = undefined;
    this.setAddressReturn(address);
  }

  callbackExchange(address: OriginalAddress) {
    (window as any).addressCallback = undefined;
    this.setAddressExchange(address);
  }

  goSelectReturnAddress() {
    (window as any).addressCallback = this.callbackReturn;
    ncpPopup('/address/search/popup?dataCallback=addressCallback', this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_POSTAL_CODE'), 550, 880);
  }

  goSelectExchangeAddress() {
    (window as any).addressCallback = this.callbackExchange;
    ncpPopup('/address/search/popup?dataCallback=addressCallback', this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_POSTAL_CODE'), 550, 880);
  }

  private onChangeReturnWayType(){
    if (this.returnWayType == 'SELLER_COLLECT'){
      this.showReturncollinfo = true;
      this.unApprovedDisabled = true
      this.unApprovedYn = false
    } else{
      if (this.responsibleObjectType == 'SELLER' && (this.postPredict as any).amounts.returnDelivery.returnDeliveryAmt > 0){
        alert(this.$t('CLAIM_RETURNPOPUP_ONCHANGERETURNWAYTYPE'));
      }
      this.showReturncollinfo = false;
      this.unApprovedDisabled = false;
    }

    if (this.pageName === 'ExchangePopupAfter' || this.pageName === 'ReturnPopup'){
      this.$emit('setData');
    }
  }

  private onClickModifyReturnAddress(){
    (window as any).displayExchangeProductOptionInputArea = this.callback;
    ncpPopup(`/claim/modify/address?claimNo=${(this.claimOrderOptions as any).no}`, this.$t('CLAIM_RETURNPOPUP_MODIRECIPIENTINFO'), 1250, 1024);
  }

  private callback(items: any) {

  }

  private onlyNumberAndEnglish(e: KeyboardEvent){
    const $taget = e.target as HTMLInputElement;
    $taget.value=$taget.value.replace(/[^0-9a-zA-Z]/g,'');
  }

  private checkOnlyIntegerAndAlphabet(e: KeyboardEvent){
    // Allow:  , escape, enter
    if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'].includes(e.key) ||
      // Allow: Ctrl + A/X/V/C or Command + A/X/V/C
      (e.key === 'Control'|| e.metaKey) ||
      // Allow: home, end, left, right, down, up
      (['Home', 'End', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp'].includes(e.key))) {
      // let it happen, don't do anything
      return;
    }

    //TODO: keyCode는 deprecated 되었음.  타 QA 해결 후 수정
    // 영어 대소문자 허용
    if ((e.keyCode > 64 && e.keyCode < 91) || (e.keyCode > 96 && e.keyCode < 123)) {
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  }

  private get isNaverPay(){
    return this.payType === 'NAVER_PAY';
  }
}
